import axios from 'axios';

import type {
  IUserGetTransfersRequest,
  IUserGetTransfersResponse,
} from '@/app-package';

const getTransfers = async (params: IUserGetTransfersRequest['params']) => {
  const { data } = await axios.get<IUserGetTransfersResponse>('/transfer', {
    params,
  });

  return data;
};

export default getTransfers;
